// tienda/ProcesoSection.jsx
// Horizontal operating flow for how Fast Max handles an order.

import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2, FileSpreadsheet, MessageCircle, Truck } from "lucide-react";
import { brand, fadeUp } from "../shared/brand";

const STEPS = [
  { title: "Carga pedidos", icon: <FileSpreadsheet className="size-5" />, text: "Registra uno por uno o sube un Excel con toda tu venta del día.", meta: "Excel o panel" },
  { title: "Recojo y despacho", icon: <Truck className="size-5" />, text: "Recogemos en tu tienda o preparamos el pedido desde almacén FM.", meta: "Ruta optimizada" },
  { title: "Cliente informado", icon: <MessageCircle className="size-5" />, text: "WhatsApp automático mantiene al comprador actualizado sin fricción.", meta: "Mensajes por estado" },
  { title: "Entrega confirmada", icon: <CheckCircle2 className="size-5" />, text: "Validamos entrega, contraentrega y cierre operativo desde el dashboard.", meta: "COD conciliado" },
];

export function ProcesoSection() {
  return (
    <section id="proceso" className="border-b scroll-mt-16" style={{ background: brand.bg, borderColor: brand.line }}>
      <div className="mx-auto max-w-7xl px-4 py-14 md:py-20">
        <motion.div {...fadeUp} className="mb-10 max-w-2xl">
          <p className="mb-3 text-xs font-black uppercase tracking-[0.2em]" style={{ color: brand.primary }}>
            Flujo de entrega
          </p>
          <h2 className="text-3xl font-black md:text-4xl" style={{ color: brand.ink }}>
            De venta recibida a pedido cerrado, sin perder visibilidad.
          </h2>
        </motion.div>

        <div className="relative grid gap-4 lg:grid-cols-4">
          <div className="absolute left-0 right-0 top-10 hidden h-px lg:block" style={{ background: brand.line }} />
          {STEPS.map((step, index) => (
            <motion.div
              key={step.title}
              {...fadeUp}
              transition={{ ...fadeUp.transition, delay: index * 0.07 }}
              className="relative rounded-2xl border bg-white p-5 shadow-sm"
              style={{ borderColor: brand.line }}
            >
              <div className="mb-5 flex items-center justify-between">
                <span className="grid size-11 place-items-center rounded-xl text-white shadow-lg" style={{ background: index % 2 ? brand.plum : brand.primary }}>
                  {step.icon}
                </span>
                <span className="rounded-full px-2.5 py-1 text-[11px] font-bold" style={{ background: `${brand.accentGold}18`, color: brand.plum }}>
                  {step.meta}
                </span>
              </div>
              <p className="text-xs font-black uppercase tracking-[0.18em]" style={{ color: brand.primary }}>
                Paso {index + 1}
              </p>
              <h3 className="mt-2 text-base font-black" style={{ color: brand.ink }}>{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed" style={{ color: brand.muted }}>{step.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
